import React, {useMemo} from 'react'
import styled from 'styled-components'
import {TranslationKeyGiftShop, useTranslation} from 'i18n'
import {getCurrencyValue} from 'utils'
import {Button, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {WINDOW_MODE_MOBILE_WIDTH} from 'consts'

const StyledConfirmationModal = styled.div`
  width: ${convertUnit(400)};
  background-color: ${({theme}) => theme.white_1};
  border-radius: ${convertUnit(8)};
  position: relative;
  padding: ${convertUnit(24)};
  z-index: 5;
  @media (max-width: ${WINDOW_MODE_MOBILE_WIDTH}px) {
    width: ${convertUnit(275)};
  }
`

const StyledList = styled.ul`
  padding-left: ${convertUnit(24)};
`
const StyledListParagraph = styled(Paragraph)`
  line-height: ${convertUnit(20)};
`

const StyledButtonClose = styled(Button)`
  width: 100%;
  margin-right: ${convertUnit(25)};
`

interface TemplateMyBalanceContentSettlementInfoProps {
  visible: boolean
  toggleModal: () => void
  settlementBalance: number
}

export default function TemplateMyBalanceContentSettlementInfo({
  visible,
  toggleModal,
  settlementBalance,
}: TemplateMyBalanceContentSettlementInfoProps) {
  const {translate} = useTranslation()

  const points = useMemo<TranslationKeyGiftShop[]>(
    () => [
      'giftShop:walletSettlementInfo1',
      'giftShop:walletSettlementInfo2',
      'giftShop:walletSettlementInfo3',
      'giftShop:walletSettlementInfo4',
    ],
    [],
  )

  return (
    <Modal
      visible={visible}
      onBackdropPress={() => {
        toggleModal()
      }}>
      <StyledConfirmationModal>
        <Paragraph fontSize="m" color="primary_5">
          {translate('giftShop:walletSettlement')}
        </Paragraph>
        <Paragraph fontSize="xl" fontWeight="medium" color="primary_5">
          {getCurrencyValue(settlementBalance)}
        </Paragraph>
        <StyledList>
          {points.map((point) => (
            <li key={point}>
              <StyledListParagraph>{translate(point)}</StyledListParagraph>
            </li>
          ))}
        </StyledList>
        <StyledButtonClose
          label={translate('global:close')}
          width={convertUnit(125)}
          backgroundHoverColor="white_4"
          backgroundColor="white_2"
          color="primary_5"
          onClick={() => {
            toggleModal()
          }}
        />
      </StyledConfirmationModal>
    </Modal>
  )
}
